import { createSignal } from 'solid-js';

/**
 * The moment the pointer is over, shared across every chart on a page.
 *
 * A date rather than an x position, because the charts that link do not share an
 * axis: the price chart is drawn against time and the distribution chart against
 * payment number, so there is no pixel or fraction that means the same thing in
 * both. A date does, and each chart maps it onto whatever it plots against —
 * which is also why the distribution chart's crosshair steps between payments
 * while the price chart's slides: that is what its x-axis actually is.
 *
 * Only the chart under the pointer shows a tooltip. The crosshair is the shared
 * part; two tooltips fighting over the cursor would be worse than none.
 */
const [hoverAt, setHoverAt] = createSignal<number | null>(null);

export { hoverAt, setHoverAt };

export const clearHover = (): void => {
    setHoverAt(null);
};
